var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / General / Lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 5.33341H11.3334C11.8638 5.33341 12.3726 5.54412 12.7476 5.91919C13.1227 6.29426 13.3334 6.80297 13.3334 7.33341V12.6667C13.3334 13.1972 13.1227 13.7059 12.7476 14.081C12.3726 14.456 11.8638 14.6667 11.3334 14.6667H4.66675C4.13631 14.6667 3.62761 14.456 3.25253 14.081C2.87746 13.7059 2.66675 13.1972 2.66675 12.6667V7.33341C2.66675 6.80297 2.87746 6.29426 3.25253 5.91919C3.62761 5.54412 4.13631 5.33341 4.66675 5.33341H5.33341V4.0734C5.33341 3.36616 5.61437 2.68788 6.11446 2.18779C6.61456 1.68769 7.29284 1.40674 8.00008 1.40674C8.70733 1.40674 9.3856 1.68769 9.8857 2.18779C10.3858 2.68788 10.6667 3.36616 10.6667 4.0734V5.33341ZM7.04294 3.09474C6.79305 3.35837 6.65778 3.71027 6.66675 4.0734V5.33341H9.33341V4.0734C9.34238 3.71027 9.20712 3.35837 8.95723 3.09474C8.70734 2.8311 8.36318 2.67721 8.00008 2.66674C7.63699 2.67721 7.29283 2.8311 7.04294 3.09474ZM7.07413 8.61438C7.34821 8.43124 7.67045 8.3335 8.00008 8.3335C8.44211 8.3335 8.86603 8.50909 9.17859 8.82165C9.49115 9.13421 9.66675 9.55814 9.66675 10.0002C9.66675 10.3298 9.569 10.652 9.38586 10.9261C9.20273 11.2002 8.94243 11.4138 8.63789 11.54C8.33334 11.6661 7.99823 11.6991 7.67493 11.6348C7.35163 11.5705 7.05466 11.4118 6.82157 11.1787C6.58848 10.9456 6.42975 10.6486 6.36544 10.3253C6.30113 10.002 6.33414 9.6669 6.46028 9.36236C6.58643 9.05781 6.80005 8.79752 7.07413 8.61438Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockV2);
export default __webpack_public_path__ + "static/media/lock-v2.819ea670084e30a944336724e9e2cf9b.svg";
export { ForwardRef as ReactComponent };